<template lang="html">

    <article class="programa-activo row-start">

        <div class="contenedor-foto" v-if="!!data.urlImagen">
            <img :src="data.urlImagen" alt="">
        </div>

        <div class="contenedor-texto">
            <h2 class="titulo">{{data.titulo}}</h2>
            <h3 class="fecha">{{(!!!data.fechaFin) ? 'a partir del' : 'del'}} {{data.fechaInicio}} {{(!!data.fechaFin) ? 'al' : ''}} {{data.fechaFin}}</h3>
            <!-- <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consectetur, neque cum vero recusandae quos
                provident iusto corporis asperiores vitae molestiae, placeat maxime omnis quae mollitia ipsa nulla.
                Impedit, voluptatibus quod.</p> -->
            <a href="" class="link">Ver detalle</a>
        </div>

        <router-link class="enlace-cover" :to="$t('enlaces.programasyofertas')+'/'+data.urlAcceso"></router-link>

    </article>

</template>

<script lang="js">
    export default {
        name: 'programa-activo',
        props : ['data']
    }
</script>


// WEBPACK FOOTER //
// src/components/parts/programa-activo.vue